import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-0",attrs:{"id":"setting-screen"}},[_c(VTabs,{staticClass:"bg-white mb-4 rounded",attrs:{"value":_vm.currentTabIndex,"background-color":"transparent"},on:{"change":_vm.changeTab}},_vm._l((_vm.tabs),function(tabItem){return _c(VTab,{key:tabItem.index,attrs:{"tabindex":tabItem.index},on:{"click":function($event){return _vm.loadRoute(tabItem.routeName)}}},[_vm._v(_vm._s(tabItem.label))])}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }